module.exports = __webpack_public_path__ + "static/media/iphonex-frame.d625abbf.png";